module.exports = __webpack_public_path__ + "img/googlepay.1c25aaa0.svg";